import React from "react";
import RouteComponents from "./routes";
import ErrorHandler from "components/common/ErrorHandler";
import { errorState } from "recoil/error/atom";
import { modalState } from "recoil/modal/atom";
import ModalComponent from "components/common/ModalComponent";
import { toastMessageState } from "recoil/toast/atom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { ToastHandler } from "@qjumpers/common-ui";

import "react-toastify/dist/ReactToastify.css";

function App() {
  const error = useRecoilValue(errorState);
  const modal = useRecoilValue(modalState);
  const toast = useRecoilValue(toastMessageState);
  const setToast = useSetRecoilState(toastMessageState);

  const clearToastMessage = () => {
    setToast([]);
  };

  return (
    <div className="App">
      <ErrorHandler errors={error} />
      <ModalComponent modalData={modal} />
      <ToastHandler toast={toast} clearToasts={clearToastMessage} />
      <RouteComponents />
    </div>
  );
}

export default App;
